import React, { useEffect, useState } from "react";
import IndofastLogo from "./IndofastLogo";

function Preloader({ visible }) {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (!visible) {
      const t = setTimeout(() => setHide(true), 700);
      return () => clearTimeout(t);
    }
    setHide(false);
  }, [visible]);

  if (hide) return null;

  return (
    <div className={`preloader-overlay${visible ? "" : " preloader-exit"}`} aria-hidden="true">
      <div className="preloader-stage">

        <div className="preloader-logo-wrap">
          <div className="preloader-ring preloader-ring-outer" />
          <div className="preloader-ring preloader-ring-inner" />
          <div className="preloader-badge">
            <IndofastLogo height={36} variant="dark" />
          </div>
        </div>

        <div className="preloader-tagline">AN INDIAN OIL + SUN MOBILITY JV</div>

        <div className="preloader-bar-track">
          <div className="preloader-bar-fill" />
        </div>

      </div>
    </div>
  );
}

export default Preloader;
